import React from "react";

export const Table = ({
  headers = [],
  rows = [],
  children,
}: {
  headers?: (string | React.ReactNode)[];
  rows?: (string | React.ReactNode)[][];
  children?: React.ReactNode;
}) => {
  const safeHeaders = Array.isArray(headers) ? headers : [];
  const safeRows = Array.isArray(rows) ? rows : [];

  if (safeHeaders.length === 0 && safeRows.length === 0 && children) {
    return (
      <TableScroll>
        <table style={{ textAlign: "justify", width: "100%", borderCollapse: "collapse" }}>
          {children}
        </table>
      </TableScroll>
    );
  }

  return (
    <TableScroll>
      <table style={{ textAlign: "justify", width: "100%", borderCollapse: "collapse" }}>
      {safeHeaders.length > 0 && (
        <thead>
          <tr>
            {safeHeaders.map((header, index) => (
              <th key={index} style={{ border: "1px solid #ddd", padding: "8px" }}>
                {header}
              </th>
            ))}
          </tr>
        </thead>
      )}
      <tbody>
        {safeRows.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {Array.isArray(row) &&
              row.map((cell, cellIndex) => (
                <td key={cellIndex} style={{ border: "1px solid #ddd", padding: "8px" }}>
                  {cell}
                </td>
              ))}
          </tr>
        ))}
      </tbody>
      </table>
    </TableScroll>
  );
};

// Contiene las tablas anchas en la columna (scroll horizontal)
function TableScroll({ children }: { children: React.ReactNode }) {
  return (
    <div style={{ overflowX: "auto", maxWidth: "100%" }}>
      {children}
    </div>
  );
}

export default Table;